module.exports = __webpack_public_path__ + "static/media/Portrait-10045.d34a3a39.jpg";